module.exports = __webpack_public_path__ + "static/media/Karte1.e9350136.png";